
import Social from '@/components/social/Index.vue'
export default {
  components: { Social },
  data() {
    return {
      menu: [
        {
          text: 'Home',
          disabled: !1,
          to: '/'
        },
        {
          text: 'Nossos Clientes',
          disabled: !0,
          to: '/clinica'
        }
      ],
      title: 'Confira alguns de nossos clientes'
    }
  },
  computed: {
    site() {
      return site
    },
    height() {
      let size = 150,
        { xs, sm, mdAndUp } = this.$vuetify.breakpoint
      if (xs) size = 150
      else if (sm) size = 170
      else if (mdAndUp) size = 250
      return size
    }
  },
  created() {
    this.url = window.location.href
  }
}
